import { cn } from '@servicetim/ui/lib';
import type { ReactNode } from 'react';

/** Compact card for the detail screen's right rail. */
export function RailCard({
  title,
  actions,
  children,
  className,
}: {
  title: ReactNode;
  actions?: ReactNode;
  children: ReactNode;
  className?: string;
}) {
  return (
    <section
      aria-label={typeof title === 'string' ? title : undefined}
      className={cn(
        'rounded-lg border border-border border-t-2 border-t-accent bg-surface-raised',
        className,
      )}
    >
      <header className="flex items-center justify-between gap-2 border-border border-b px-4 py-2">
        <h2 className="font-semibold text-fg text-sm">{title}</h2>
        {actions}
      </header>
      <div className="space-y-3 px-4 py-3 text-sm">{children}</div>
    </section>
  );
}

/** Label/value row inside a rail card. */
export function RailRow({ label, children }: { label: string; children: ReactNode }) {
  return (
    <div className="grid grid-cols-[7rem_1fr] items-start gap-2">
      <dt className="text-fg-muted">{label}</dt>
      <dd className="min-w-0 text-fg">{children}</dd>
    </div>
  );
}
